<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="35%" @close="resetField">
      <div slot="content">
        <el-form ref="form" :model="filterData" label-position="top" :rules="rules">
          <div v-show="checkType">
            <el-row>
              <el-form-item label="로그명" label-width="120px" prop="applogId">
                <el-select v-model="filterData.applogId" placeholder="로그선택">
                  <el-option v-for="(item, index) in logList" :key="index" :label="item.applogId" :value="item.applogId"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="필터링 명" label-width="120px" prop="applogFilterId"><el-input placeholder="필터명을 입력하세요" v-model="filterData.applogFilterId"></el-input></el-form-item>
            </el-row>
          </div>
          <el-row>
            <el-form-item label-width="120px">
              <div slot="label">
                <span>필터링 조건 정규표현식</span>
                <el-popover placement="right" trigger="click" width="450" :offset="40">
                  <el-table-wrapper border :data="regexHelpData" :columns="regexHelpColumns" :pagination="false">
                  </el-table-wrapper>
                  <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
                </el-popover>
              </div>
              <el-input placeholder="정규 표현식을 입력하세요" v-model="filterData.filterCondition"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="필터링 예외조건 정규 표현식" label-width="120px"><el-input placeholder="예외조건 표현식을 입력하세요" v-model="filterData.exceptFilterCondition"></el-input></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="조치방법" label-width="120px">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="조치 방법을 입력하세요"
                v-model="filterData.solution"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <span v-show="checkType">
          <el-button size="large" type="solid" @click="addApplogFilter">저장</el-button>
        </span>
        <span v-show="!checkType">
          <el-button size="large" type="solid" @click="updateApplogFilter">저장</el-button>
        </span>
        <el-button @click="close" size="large" >취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import ApplogSettingAPI from '@/api/settings/log/app-log-setting';
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';

export default {
  name: 'WAppLogFilterPopup',
  components: {
    WSettingSlidingPopup,
  },
  props: {
    type: {
      type: String,
    },
    formData: {
      type: Object,
      default() {},
    },
    selectPhysicalNode: {
      type: Object,
    },
  },
  watch: {
    formData() {
      if (this.type === 'Add') {
        this.filterData = {
          applogId: '',
          applogFilterId: null,
          filterCondition: null,
          exceptFilterCondition: null,
          solution: null,
        };
      } else {
        this.filterData = this.formData;
      }
    },
    type() {
      if (this.type === 'Add') {
        this.checkType = true;
      } else {
        this.checkType = false;
      }
      this.title = (this.checkType) ? '로그 필터 추가' : '로그 필터 수정';
    },
    immediate: true,
  },
  data() {
    const regexHelpData = [
      {
        regex: '.*',
        desc: '패턴 안에서 AND 연산',
      },
      {
        regex: '|',
        desc: '패턴 안에서 OR 연산',
      },
      {
        regex: '[^]',
        desc: '\'[]\'안에 있는 문자와 일치하지 않는 문자열을 포함하고 있는 패턴',
      },
      {
        regex: '.',
        desc: '임의의 한 문자',
      },
      {
        regex: '*',
        desc: '바로 앞의 문자가 없거나 하나 이상 반복',
      },
      {
        regex: '+',
        desc: '반드시 하나 이상의 문자가 반복',
      },
      {
        regex: '?',
        desc: '특수문자의 바로 앞의 문자가 하나 있거나 없거나 함',
      },
      {
        regex: '^',
        desc: '문장의 처음',
      },
      {
        regex: '$',
        desc: '문장의 끝',
      },
      {
        regex: '[]',
        desc: '괄호 안의 문자 중 일치하는 것을 찾고자 할 경우',
      },
      {
        regex: '{}',
        desc: '문자나 문자열의 반복되는 개수',
      },
      {
        regex: '()',
        desc: '\'()\'안의 글자들을 하나의 문자로 처리',
      },
    ];

    const regexHelpColumns = [
      { prop: 'regex', label: '정규식', width: '60' },
      { prop: 'desc', label: '설명' },
    ];
    const validateFilterName = (rule, value, callback) => {
      const pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
      if (isNil(value) || isEmpty(value)) {
        callback(new Error('필수 정보 입니다.'));
      }
      if (pattern.test(value) === true) {
        callback(new Error('필터명은 영문 입력입니다.'));
      }
      callback();
    };
    return {
      regexHelpData,
      regexHelpColumns,
      title: '로그 필터 추가',
      checkType: true,
      filterData: {
        applogId: '',
        applogFilterId: null,
        filterCondition: null,
        exceptFilterCondition: null,
        solution: null,
      },
      logList: [],
      rules: {
        applogId: [
          { required: true, message: '필수 정보입니다.', trigger: 'change' },
        ],
        applogFilterId: [
          { required: true, validator: validateFilterName, trigger: 'blur' },
          { min: 1 },
        ],
      },
    };
  },
  methods: {
    /**
     * 필터 수정 적용
     * @author leesy918
     * @return {[type]} [description]
     */
    updateApplogFilter() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.filterData.serverId = this.selectPhysicalNode.serverId;
          if (isNil(this.filterData.filterCondition)) {
            this.filterData.filterCondition = ' ';
          }
          ApplogSettingAPI.updateApplogFilter(this.filterData).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '필터', true));
              this.$emit('loadData');
              this.close();
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '필터', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    /**
     * 로그 필터 추가
     * @author leesy918
     */
    addApplogFilter() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.filterData.serverId = this.selectPhysicalNode.serverId; // 서버 아이디 임시 지정
          ApplogSettingAPI.addApplogFilter(this.filterData).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '필터', true));
              this.$emit('loadData');
              this.close();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '필터', false));
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '필터', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    /**
     * 필터리스트 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      const params = {};
      params.serverId = this.selectPhysicalNode.serverId;
      ApplogSettingAPI.getApplogName(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.logList = response.data.data;
          if (this.type === 'Add' && !isEmpty(this.logList)) {
            this.filterData.applogId = this.logList[0].applogId;
          }
          this.$refs.slidingPopup.open();
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 리스트', false));
        throw new Error(e);
      });
    },
    resetField() {
      this.$refs.form.resetFields();
    },
    open() {
      this.loadData();
    },
    close() {
      this.$refs.form.resetFields();
      this.$refs.slidingPopup.close();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Applog/popup/AppLogFilterPopup.vue